module.exports = __webpack_public_path__ + "static/marten-newhall-magnifying-glass-700px-2b632c1984313611b8fa88693cd6cdcc.jpg";